import React, { useContext, useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import HtmlHead from "../components/html-head/HtmlHead";
import Marquee from "../components/marquee/Marquee";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RightMenu from "./components/RightMenu";
import { setIsOpenRightMenu } from "../store/reducers/menuReducer";
import { useDispatch, useSelector } from "react-redux";
import MainService from "../helpers/services/mainService";
import { CourseContext } from "../App";
import useWindowSize from "../components/hooks/useWindowSize";
import Header from "../components/layaut/Header";
import PaymentModal from "../components/modals/PaymentModal";
import { setLogout } from "../store/reducers/userReducer";
import { setIsShowHomePageLoader, setIsShowLoader } from "../store/reducers/loaderReducer";

const CourseTitle = ({ title, windowWidth }) => {
	const textRef = useRef(null);
	const [fitStyle, setFitStyle] = useState({});

	useEffect(() => {
		const textEl = textRef.current;
		if (!textEl || !title) {
			return;
		}
		const computed = window.getComputedStyle(textEl);
		const baseFontSize =
			parseFloat(computed.getPropertyValue("--title-size")) ||
			parseFloat(computed.fontSize);
		const baseLineHeight =
			parseFloat(computed.getPropertyValue("--title-line-height")) ||
			parseFloat(computed.lineHeight);
		if (!baseFontSize) {
			return;
		}

		const trimmed = title.trim();
		const extraChars = Math.max(trimmed.length - 7, 0);
		if (!extraChars) {
			setFitStyle({});
			return;
		}

		const ratio =
			baseLineHeight && !Number.isNaN(baseLineHeight)
				? baseLineHeight / baseFontSize
				: 0.9;
		const step = 6;
		const minFontSize = Math.max(Math.round(baseFontSize * 0.55), 20);
		const nextFontSize = Math.max(baseFontSize - extraChars * step, minFontSize);
		const nextLineHeight = Math.round(nextFontSize * ratio);

		setFitStyle({
			fontSize: `${nextFontSize}px`,
			lineHeight: `${nextLineHeight}px`,
		});
	}, [title, windowWidth]);

	return (
		<p ref={textRef} className="title mb-0 px-5" style={fitStyle}>
			{title}
		</p>
	);
};

export default function Home() {
	const windowSize = useWindowSize();
	const location = useLocation();
	const navigate = useNavigate();
	const { isShowLoader } = useSelector(state => state.loader);
	const params = new URLSearchParams(location.search);
	const blockId = params.get("id");
	const dispatch = useDispatch();
	const { courses } = useContext(CourseContext);
	const [showModal, setShowModal] = useState(false);
	const [modalData, setModalData] = useState({
		title: "",
		message: "",
		isSuccess: false,
	});

	const title = "Главная";
	const description = "";

	useEffect(() => {
		dispatch(setIsShowHomePageLoader(true));
		setTimeout(() => {
			dispatch(setIsShowHomePageLoader(false));
		}, 1000);
	}, [])

	useEffect(() => {
		if (blockId) {
			setTimeout(() => {
				MainService.scrollToCurrentBlockById(blockId);
			}, 500);
		}
	}, [blockId]);

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const successParam = params.get("Success") ?? params.get("success");
		const normalized = successParam ? successParam.toLowerCase() : null;

		if (normalized === "true" || normalized === "false" || normalized === "1" || normalized === "0") {
			const isSuccess = normalized === "true" || normalized === "1";

			setModalData({
				title: isSuccess ? "Ура! Вы приобрели курс." : "Что-то пошло не так...",
				message: isSuccess
					? "Данные для входа в личный кабинет Вы можете найти на почте. Желаем лёгких и продуктивных занятий!"
					: "В процессе оплаты возникла ошибка. Пожалуйста, попробуйте ещё раз.",
				isSuccess,
			});

			setShowModal(true);
		}
	}, [location.search]);

	const handleClose = () => {
		if (!modalData.isSuccess) {
			dispatch(setLogout());
		} else {
			navigate("/account");
		}
		setModalData({
			title: "",
			message: "",
			isSuccess: false,
		});
		setShowModal(false);
	};

	return (
		<>
			<PaymentModal
				show={showModal}
				handleClose={handleClose}
				title={modalData.title}
				message={modalData.message}
				isSuccess={modalData.isSuccess}
			/>
			<div className="home">
				<HtmlHead title={title} description={description} />
				<RightMenu>
					<div>
						<Link
							to="/?id=courses"
							className="link "
							onClick={() => {
								dispatch(setIsOpenRightMenu(false));
							}}>
							курсы
						</Link>
						<Link
							to="/?id=about"
							className="link"
							onClick={() => {
								dispatch(setIsOpenRightMenu(false));
							}}>
							обо мне
						</Link>
					</div>
				</RightMenu>

				<Header>
					<div className="w-100 d-flex">
						<div className="d-flex justify-content-center w-100 gap-3">
							<Link to="/?id=courses" className={`header-button text-nowrap px-40`}>
								курсы
							</Link>
							<Link to="/?id=about" className={`header-button text-nowrap px-40`}>
								обо мне
							</Link>
						</div>
					</div>
				</Header>
				<Container className="position-relative">
					<section className="age-section">
						<h2 className="age-section-title soyuz">
							<span className="text-nowrap">студия развития </span>
							<br className="d-block d-md-none" />
							<span className="text-animate green-text text-nowrap">
								детской речи
							</span>
							<br />
							<span className="text-nowrap">натальи смагиной</span>
						</h2>
						<div className="d-flex age-dark-block">
							<div className="age-block">
								<div className="d-flex flex-column gap-2">
									<div className="dark-block dark-small-block d-flex justify-content-center align-items-center">
										<span className="white-text d-block">для детей</span>
									</div>
									<div className="dark-block dark-big-block d-flex justify-content-around align-items-center">
										<div className="d-flex flex-column align-items-center">
											<span className="white-text">от</span>
											<span className="secondary-text">0</span>
										</div>
										<div className="d-flex flex-column align-items-center">
											<span className="white-text">до</span>
											<span className="secondary-text">7</span>
										</div>
									</div>
								</div>
							</div>
							<div className="home-page-cat">
								<img src="/gif/home.gif" />
							</div>
						</div>
					</section>
				</Container>
				<Marquee
					content={
						windowSize.width > 1024
							? [
								"развиваемся",
								"говорим",
								"играем",
								"развиваемся",
								"говорим",
								"играем",
							]
							: ["развиваемся", "говорим", "играем"]
					}
					blockClassName="dark-bg"
				/>
				<section className="course-section" id="courses">
					<Container>
						<Row>
							<Col sm={12}>
								<div className="courses-block">
									{courses && courses.length
										? courses.map((item, index) => {
											if (index % 2 === 0) {
												return (
													<div key={index} className="my-5 mt-lg-0 course">
														<div className="course-block">
															<div
																className="position-relative"
																style={{ display: "inline-block" }}>
																<div
																	className="course-1"
																	data-course-title-container>
																	<div className="d-flex align-items-end h-100 justify-content-center">
																		<CourseTitle title={item.title} windowWidth={windowSize.width} />
																	</div>
																</div>
																<Link
																	to={`/course-view/${item.id}`}
																	className="course-1-more">
																	<div className="d-flex align-items-center h-100">
																		<span className="learn-more d-block text-center">
																			узнать больше
																		</span>
																	</div>
																</Link>
															</div>
															<div className="description-block">
																<div className="d-flex description align-items-center px-3 h-100">
																	{item.miniDescription} {item.eligibility}
																</div>
															</div>
														</div>
													</div>
												);
											} else {
												return (
													<div key={index} className="my-5 mt-lg-0 course">
														<div className="d-lg-flex justify-content-end">
															<div className="course-block">
																<div
																	className="d-flex position-relative"
																	style={{ display: "inline-block" }}>
																<Link
																	to={`/course-view/${item.id}`}
																	className="course-2-more">
																	<div className="d-flex align-items-center h-100">
																		<span className="learn-more d-block text-center">
																			узнать больше
																		</span>
																	</div>
																</Link>
																<div
																	className="course-2"
																	data-course-title-container>
																	<div className="d-flex h-100 justify-content-center">
																		<CourseTitle title={item.title} windowWidth={windowSize.width} />
																	</div>
																</div>
															</div>
																<div className="description-block">
																	<div className="d-flex description align-items-center px-3 h-100">
																		{item.miniDescription} {item.eligibility}
																	</div>
																</div>
															</div>
														</div>
													</div>
												);
											}
										})
										: null}
								</div>
							</Col>
						</Row>
					</Container>
				</section>
				<section className="arrow-section">
					<img src="/images/arrow.svg" />
				</section>
				<Container>
					<section className="bio-section" id="about">
						<Row>
							<Col md={5} sm={12}>
								<div>
									<p className="title soyuz">смагина наталья</p>
									<div className="description pb-5">
										<p className="mt-5 mb-0">
											Более 20 лет я стою на страже детского развития. Делюсь с
											вами огромным практическим опытом по речевому развитию
											детей.
										</p>
										<p className="mt-4 mb-0">Ваш логопед,</p>
										<p>Смагина Наталья</p>
									</div>
								</div>
							</Col>
							<Col md={7} sm={12}>
								<div className="autor-block">
									<img className="autor" src="/images/autor.svg" />
								</div>
							</Col>
						</Row>
					</section>
				</Container>
			</div>
			<Marquee
				content={
					windowSize.width > 1024
						? [
							"логопед-дефектолог",
							"наталья смагина",
							"логопед-дефектолог",
							"наталья смагина",
						]
						: ["логопед-дефектолог", "Наталья Смагина"]
				}
				blockClassName="dark-bg"
			/>
		</>
	);
}
